import request, { PATCH } from '../../utils/request';

export default body => request('/pre-settlement-requests', { method: PATCH, body });
